import * as React from "react";
import { useTranslation, Trans } from "react-i18next";
import ViewTypeLabel from "views/components/ViewTypeLabel";
import useViewType from "views/hooks/useViewType";
import useViewMetadata from "views/hooks/useViewMetadata";
import { MoreActionsIcon } from "components/common/MoreActions";
import SearchResultOverview from "./SearchResultOverview";
import SectionInfo from "../SectionInfo";
import SectionSubheadline from "../SectionSubheadline";
const ViewDescription = ({ results }) => {
  const { t } = useTranslation("search");
  const viewMetadata = useViewMetadata();
  const isAdHocSearch = !viewMetadata.id;
  const viewType = useViewType();
  const viewTypeLabel = viewType ? ViewTypeLabel({ type: viewType }) : "";
  const resultsSection = /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionSubheadline, null, t("sidebar_description.execution")), /* @__PURE__ */ React.createElement(SearchResultOverview, { results }));
  if (isAdHocSearch) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionInfo, null, t("sidebar_description.ad_hoc_info")), resultsSection);
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, (!viewMetadata.summary || !viewMetadata.description) && /* @__PURE__ */ React.createElement(SectionInfo, null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      i18nKey: "sidebar_description.edit_metadata_hint",
      ns: "search",
      values: { viewType: viewTypeLabel },
      components: { icon: /* @__PURE__ */ React.createElement(MoreActionsIcon, null) }
    }
  )), resultsSection, /* @__PURE__ */ React.createElement(SectionSubheadline, null, t("sidebar_description.search_section")), /* @__PURE__ */ React.createElement("p", null, viewMetadata.summary || /* @__PURE__ */ React.createElement("i", null, t("sidebar_description.no_summary", { viewType: viewTypeLabel }))), /* @__PURE__ */ React.createElement("p", null, viewMetadata.description || /* @__PURE__ */ React.createElement("i", null, t("sidebar_description.no_description", { viewType: viewTypeLabel }))));
};
export default ViewDescription;
